// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__uhMEm","left":"StickyBox_left__O8j57","right":"StickyBox_right__CaCpO"};